var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"tab-bar"},[_c('div',{staticClass:"tab-bar-inner",class:{ 'line-top': _vm.lineTop }},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }